import React, { useMemo } from 'react';
import { Box, styled } from '@mui/material';
import { METRIC_CARDS } from 'dashboard409a/common/constants/components/metrics';
import { Medians } from 'dashboard409a/services/types';
import MetricCard from './MetricCard';

const PREFIX = 'MetricCardsRow';

const classes = {
  container: `${PREFIX}-container`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(170px, 100%), 1fr))',
    margin: '16px 0',
  },
}));

interface MetricCardsRowProps {
  medians: Medians;
}

const MetricCardsRow = ({ medians }: MetricCardsRowProps) => {
  const {
    ntm_revenue_multiple: ntmRevenueMultiple,
    ntm_revenue_growth: ntmRevenueGrowth,
    gross_margin: grossMargin,
    ltm_revenue_multiple: ltmRevenueMultiple,
    ltm_revenue_growth: ltmRevenueGrowth,
    ebitda_margin: ebitdaMargin,
  } = medians;
  const metricCards = useMemo(
    () =>
      METRIC_CARDS(
        ntmRevenueMultiple,
        ntmRevenueGrowth,
        grossMargin,
        ltmRevenueMultiple,
        ltmRevenueGrowth,
        ebitdaMargin
      ),
    [ebitdaMargin, grossMargin, ltmRevenueGrowth, ltmRevenueMultiple, ntmRevenueGrowth, ntmRevenueMultiple]
  );

  return (
    <StyledBox className={classes.container}>
      {metricCards.map(card => (
        <MetricCard key={card.id} title={card.title} format={card.format as 'x' | '%'} value={card.value} />
      ))}
    </StyledBox>
  );
};

export default MetricCardsRow;
